// Press-to-talk dictation into the Dev Console composer (Web Speech API):
// long specs where the dock's turn-taking is awkward. Appends interim and
// final transcripts to the draft; hidden where the browser has no
// SpeechRecognition (Firefox) — the dock's voice still works there.
import React, { useEffect, useRef, useState } from 'react';

const SR = typeof window !== 'undefined' ? (window.SpeechRecognition || window.webkitSpeechRecognition) : null;

export default function DictateButton({ onStart, onText, disabled }) {
  const [on, setOn] = useState(false);
  const recRef = useRef(null);
  useEffect(() => () => { try { recRef.current?.stop(); } catch (_) { /* gone */ } }, []);
  if (!SR) return null;
  const stop = () => { try { recRef.current?.stop(); } catch (_) { /* gone */ } recRef.current = null; setOn(false); };
  const start = () => {
    const rec = new SR();
    rec.continuous = true;
    rec.interimResults = true;
    rec.lang = navigator.language || 'en-US';
    if (onStart) onStart();
    rec.onresult = (e) => {
      let finalText = '';
      let interim = '';
      for (let i = 0; i < e.results.length; i += 1) {
        const t = e.results[i][0]?.transcript || '';
        if (e.results[i].isFinal) finalText += t; else interim += t;
      }
      onText(`${finalText}${interim}`.trim());
    };
    rec.onend = () => { recRef.current = null; setOn(false); };
    rec.onerror = () => { recRef.current = null; setOn(false); };
    try { rec.start(); recRef.current = rec; setOn(true); } catch (_) { setOn(false); }
  };
  return (
    <button
      type="button"
      className={`devc-btn devc-btn-icon${on ? ' devc-dictating' : ''}`}
      aria-label={on ? 'Stop dictating' : 'Dictate into the composer'}
      aria-pressed={on}
      title={on ? 'Stop dictating' : 'Dictate (speech to text, appended to the draft)'}
      disabled={disabled}
      onClick={() => (on ? stop() : start())}
      data-agent-noclick
    >
      {on ? '⏺' : '🎙'}
    </button>
  );
}
